import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";
import {
  CreateMyEmbeddedCheckoutOutput,
  GetProductGroupByPromoCodeInput,
} from "./types";

export const getCustomerQuota: ApiMethod<
  void,
  Api.Server.CustomerQuota
> = async (_, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Plans_Client(
          undefined,
          Api.apiClient
        );

        return client.plans_customerQuota_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getProductGroupDefault: ApiMethod<
  void,
  Api.Server.ProductGroupWithProductsOutput
> = async (_, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ProductGroup_Client(
          undefined,
          Api.apiClient
        );

        return client.productGroup_default_get_V1(
          undefined,
          undefined,
          Api.Server.PurchaseSource.STRIPE
        );
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};

export const getProductGroupByPromoCode: ApiMethod<
  GetProductGroupByPromoCodeInput,
  Api.Server.ProductGroupWithProductsOutput
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ProductGroup_Client(
          undefined,
          Api.apiClient
        );

        return client.productGroup_byPromoCode_get_V1(
          undefined,
          undefined,
          body.promoCode,
          Api.Server.PurchaseSource.STRIPE
        );
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};

export const getFeaturesByPlanId: ApiMethod<
  number,
  Api.Server.FeatureOutput[]
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Features_Client(
          undefined,
          Api.apiClient
        );

        return client.features_byPlan_get_V1(
          undefined,
          undefined,
          undefined,
          id
        );
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};

export const createMyPaymentIntent: ApiMethod<
  Api.Server.CreateMyStripePaymentIntentInput,
  CreateMyEmbeddedCheckoutOutput
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Stripe_Client(
          undefined,
          Api.apiClient
        );

        return client.stripe_createMyPaymentIntent_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};

export const createBehaviourEvent: ApiMethod<
  Api.Server.CreateBehaviourEventInput,
  number,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_BehaviourEvent_Client(
          undefined,
          Api.apiClient
        );

        return client.behaviourEvent_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};

export const redeemCredit: ApiMethod<
  Api.Server.RedeemContentEntityWithCreditInput,
  Api.Server.CustomerQuota
> = async (contentEntityId, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Allowings_Client(
          undefined,
          Api.apiClient
        );
        return client.allowings_redeemCredit_post_V1(contentEntityId);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getProductGroupContent: ApiMethod<
  void,
  Api.Server.ProductGroupWithProductsOutput
> = async (_, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ProductGroup_Client(
          undefined,
          Api.apiClient
        );

        return client.productGroup_content_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "modal"
  );
};
